import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const createSurvey = createAsyncThunk(
  "api/fetchData",
  async (userData, { rejectWithValue }) => {
    let config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    };
    try {
      const response = await axios.post(
        `${API_BASE_URL}/survey`,

        userData,
        config
      );
      let status = "success";
      let data = {
        status: status,
        message: response,
      };
      return data;
    } catch (error) {
      let status = "error";
      let data = {
        status: status,
        message:
          error.response?.data || "Something went wrong, please try again.",
      };
      return data;
    }
  }
);

const createSurveySlice = createSlice({
  name: "api",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createSurvey.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createSurvey.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(createSurvey.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default createSurveySlice.reducer;
